<div class="border-div box-height">
  <div class="d-flex filter-header-rt" style="align-items:normal;">
    <h2 class="mainhead mr-auto">
      <span class="text">Negative Feedback Summary</span>
    </h2>
  </div>
  <div *ngIf="!isFromPortfolio" class="ct" id="containerdata"></div>
  <div *ngIf="isFromPortfolio" style="filter: blur(4px);
  -webkit-filter: blur(4px);" class="ct" id="containerdata"></div>
</div>
